
const en_US_shell = {
    "settings.settings": "Settings",
    "settings.security": "Security",
    "settings.busiessProfile": "Business profile",
    "settings.profile": "My profile",
    "settings.accounts": "Accounts",
    "settings.passwordChange": "Change password  success",
    "settings.Admin": "Roles and permissions",
    "settings.Subscribes": "Service subscription",
    "settings.MerchantUsers": "Users",
    "settings.serviceSettings": "Service settings",

    "setting.passwordNewAndOldSame": "The new password can't equal current password!",
    "setting.passwordNotMatch": "The new password that you entered do not match!",

    "businessProfile.businessProfile": "Edit business profile",
    "businessProfile.merchantId": "Merchant ID",
    "businessProfile.company": "Company",
    "businessProfile.contactEmail": "Contact email",
    "businessProfile.contactPhone": "Contact phone",
    "businessProfile.frontendUrl": "Frontend url",
    "businessProfile.timeZone": "Time zone",

    "profile.editProfile": "Edit my profile",
    "profile.merchantId": "Merchant ID",
    "profile.userId": "User ID",
    "profile.save": "Save",
    "profile.firstName": "First name",
    "profile.lastName": "Last name",
    "profile.userEmail": "User email",
    "profile.saveProfileSuccess": "Save profile  success",
    "profile.MyProfile": "My profile",

    "merchantUsers.users": "Users",
    "merchantUsers.role": "Role",
    "merchantUsers.email": "Email",
    "merchantUsers.createdAt": "Account created",
    "merchantUsers.updatedAt": "Last modified",
    "merchantUsers.action": "Action",
    "merchantUsers.addUserTitle": "Create user",
    "merchantUsers.editUserTitle": "Edit user",
    "merchantUsers.addBtn": "Add new user",
    "merchantUsers.manageRolePermissionsBtn": "Manage role permissions",
    "merchantUsers.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantUsers.filterBtn": "Filter",
    "merchantUsers.first_name": "Firstname",
    "merchantUsers.last_name": "Lastname",
    "merchantUsers.role_id": "Role",
    "merchantUsers.merchant_id": "Merchant company",
    "merchantUsers.activeFilters": "Active filters:",
    "merchantUsers.merchantCompany": "Merchant company",
    "merchantUsers.deleteMerchantUser": "Delete merchant user",
    "merchantUsers.confirmModalDelMsg": "Are you sure to delete merchant user data with email equal {email}?",
    "merchantUsers.permissionTitle": "{username}'s permission",
    "merchantUser.permissons": "Permisson",
    "merchantUser.serviceCode": "Service code",
    "merchantUser.isMarketplace": "Is market place",
    "merchantUser.planRange": "Plan range",

    "merchantsVendor.addBtn": "Create new service vendor",
    "merchantsVendor.filterBtn": "Filter",
    "merchantsVendor.activeFilters": "Active filters:",
    "merchantsVendor.addMerchantTitle": "Create service vendor",
    "merchantsVendor.editMerchantTitle": "Edit service vendor",
    "merchantsVendor.createdAt": "Instance created",
    "merchantsVendor.updatedAt": "Last modified",
    "merchantsVendor.action": "Action",
    "merchantsVendor.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantsVendor.active": "Active",
    "merchantsVendor.instanceId": "Instance ID",
    "merchantsVendor.serviceId": "Merchant service",
    "merchantsVendor.serviceStartDate": "Service start date",
    "merchantsVendor.serviceEndDate": "Service end date",
    "merchantsVendor.vendorId": "Vendor ID",
    "merchantsVendor.vendorCode": "Vendor code",
    "merchantsVendor.vendorName": "Vendor name",
    "merchantsVendor.vendorContactEmail": "Vendor contact email",
    "merchantsVendor.vendorContactPhone": "Vendor contact phone",
    "merchantsVendor.frontendApiGateway": "Frontend api gateway",
    "merchantsVendor.vendorMerchantId": "Vendor merchant",
    "merchantsVendor.merchantId": "Merchant",
    "merchantsVendor.vendor_merchant_id": "Vendor merchant",
    "merchantsVendor.merchant_id": "Merchant",
    "merchantsVendor.vendor_name": "Vendor name",
    "merchantsVendor.vendor_code": "Vendor code",
    "merchantsVendor.deleteMerchantServiceInstance": "Delete instance",
    "merchantsVendor.confirmModalDelMsg": "Are you sure to delete vendor data with vendor id equal {vendorid}?",

    "inviteAccept.register": "Sign up",
    "inviteAccept.acceptInvitation": "Accept invitation",
    "inviteAccept.inviteAccept": "Invitation accepted success!",
    "inviteAccept.createSuccess": "Create account success!",
    "inviteAccept.AcceptionSuccess": "Accept success",

    "merchantSubscribes.filterBtn": "Filter",
    "merchantSubscribes.activeFilters": "Active filters:",
    "merchantSubscribes.serviceName": "Service name",
    "merchantSubscribes.planName": "Plan name",
    "merchantSubscribes.planStartDate": "Start date",
    "merchantSubscribes.planEndDate": "End date",
    "merchantSubscribes.planExtendDate": "Extend date",


    "login.panelName": "Login",
    "login.loginBtn": "Login",
    "login.panelRightSpan": "Don’t have an account?",
    "login.panelRightSpanButton": "Register a new account",
    "login.rememberMeLabel": "Remember me",
    "login.forgetBtn": "Forget password ?",

    "passwordForget.passwordReset": "Password reset",
    "passwordForget.panelRightSpan": "We will help you reset your password",
    "passwordForget.rememberedPassword": "Remembered your password?",
    "passwordForget.navigateBack": "Back to sign in",
    "passwordForget.label_code": "Verification code",
    "passwordForget.placeholder_code": "verification code",
    "passwordReset.passwordReset": "Password reset",
    "passwordReset.panelRightSpan": "We will help you reset your password",
    "passwordReset.rememberedPassword": "Remembered your password?",
    "passwordReset.navigateBack": "Back to sign in",
    "passwordReset.passwordNotMatch": "The new password that you entered do not match!",
    "passwordResetSuccess.successful": "Successful",
    "passwordResetSuccess.panelRightSpan": "The password has been changed successfully",
    "passwordResetSuccess.navigateBack": "Back to sign in",

    "userAdmin.userAdmin": "User Admin",

    "roleAdmin.role_name": "Role name",
    "roleAdmin.role": "Role",
    "roleAdmin.created_at": "Role created",
    "roleAdmin.updated_at": "Last modified",
    "roleAdmin.action": "Action",
    "roleAdmin.addTitle": "Create role",
    "roleAdmin.editTitle": "Edit role",
    "roleAdmin.addBtn": "Add role",
    "roleAdmin.totalsSummary": "Showing {from} to {to} of {total} results",
    "roleAdmin.filterBtn": "Filter",
    "roleAdmin.description": "Description",
    "roleAdmin.is_system": "Is system",
    "roleAdmin.role_id": "Role",
    "roleAdmin.activeFilters": "Active filters:",
    "roleAdmin.deleteMerchantUser": "Delete role",
    "roleAdmin.confirmModalDelMsg": "Are you sure to delete role data with role name equal {role_name}?",
    "roleAdmin.permissionTitle": "{role_name}'s permission",
    "roleAdmin.permissons": "Permisson",
    "roleAdmin.yes": "Yes",
    "roleAdmin.no": "No",
    "roleAdmin.slug": "Slug",
    "roleAdmin.status": "Status",
    "form.enabled": "Enabled",
    "form.disabled": "Disabled",
    "roleAdmin.enabled": "Enabled",
    "roleAdmin.disabled": "Disabled",

    "merchantUsers.user_email": "Email",
    "appAccess.serviceUnavailableTitle": "Service unavailable",
    "appAccess.serviceUnavailableDescription": "This service is currently unavailable because one or more dependent services are not enabled for this merchant.",
    "appAccess.serviceUnavailableDependencies": "Contact sales to enable: {services}.",
    "appAccess.accessDeniedTitle": "Access denied",
    "appAccess.accessDeniedDescription": "Your current role does not have permission to access this page.",
    "appAccess.accessDeniedDetail": "Contact your administrator if you need access to this service.",
    "appAccess.appUnavailableEyebrow": "App unavailable",
    "appAccess.appNotFoundTitle": "App not found",
    "appAccess.appNotFoundDescription": "The selected app does not exist in the current shell catalog.",
    "appAccess.goToApp": "Go to app",
    "appAccess.backToDashboard": "Back to dashboard",
    "appAccess.accessDeniedEyebrow": "Access denied",
    "appAccess.unavailableAppEyebrow": "Unavailable app",
    "appAccess.noDescription": "No app description is available for this entry.",
    "appAccess.permissionDeniedNote": "This service is enabled for the merchant, but your current role cannot access it.",
    "appAccess.dependencyMissingNote": "This service depends on: {services}. Contact sales to enable the required service apps.",
    "appAccess.unavailableNote": "This app is visible for discovery, but it is not currently available in this merchant workspace.",
    "appAccess.viewDocs": "View docs",
    "appAccess.contactSales": "Contact sales",
    "form.back": "Back",
    "ApiConsumer.userName": "User name",
    "ApiConsumer.user_name": "User name",
    "ApiConsumer.api_key": "API Key",
    "ApiConsumer.api_secret": "API Secret",
    "ApiConsumer.mcp_id": "MCP Id",
    "merchantAccount.merchantCompany": "Merchant Company",
    "merchantAccount.merchantCode": "Merchant Code",
    "merchantAccount.timeZone": "Time Zone",
    "merchantAccount.action": "Action",
    "merchantAccount.switch": "View",
    "merchantAccount.merchantLoginError": "Merchant login failed",
    "form.userName": "User name",
    "form.userNamePlaceholder": "User name",
    "form.apiKey": "API Key",
    "form.apiKeyPlaceholder": "API Key",
    "form.apiSecret": "API Secret",
    "form.apiSecretPlaceholder": "API Secret",
    "form.mcpId": "MCP Id",
    "form.mcpIdPlaceholder": "MCP Id",
    "ApiConsumer.addBtn": "Add API consumer",
    "ApiConsumer.filterBtn": "Filter",
    "ApiConsumer.activeFilters": "Active filters:",
    "merchantApiConsumer.userName": "User name",
    "merchantApiConsumer.entityId": "Entity ID",
    "merchantApiConsumer.merchantCode": "Merchant code",
    "merchantApiConsumer.mcpId": "MCP Id",
    "merchantApiConsumer.merchantId": "Merchant ID",
    "merchantApiConsumer.apiKey": "API key",
    "merchantApiConsumer.apiSecret": "API secret",
    "merchantApiConsumer.isActive": "Is Active",
    "merchantApiConsumer.Enabled": "Enabled",
    "merchantApiConsumer.disabled": "Disabled",
    "merchantApiConsumer.apiTree": "API Tree",
    "merchantApiConsumer.created_at": "Created at",
    "merchantApiConsumer.updated_at": "Last Modified",
    "merchantApiConsumer.apitree": "API Tree",
    "ApiConsumer.action": "Action",
    "ApiConsumer.totalsSummary": "Showing {from} to {to} of {total} results",
    "form.merchantCode": "Merchant Code",
    "form.merchantCodePlaceholder": "Merchant code",
    "form.isActive": "Is active",
    "form.statusPlaceholder": "Status",
    "ApiConsumer.permissionTitle": "{role_name}'s permission",
    "global.noPermission": "Sorry, you have no permission to access this.",
    "ApiConsumer.addTitle": "Create API consumer",
    "ApiConsumer.editTitle": "Edit API consumer",
    "ApiConsumer.deleteApiConsumer": "Delete API consumer",
    "ApiConsumer.confirmModalDelMsg": "Are you sure you want to delete this API consumer?",
    "form.contactPhonePlaceholder": "Contact phone",
    "merchantSettings.fieldName": "Field Name",
    "merchantSettings.fieldCode": "Field Code",
    "merchantSettings.fieldType": "Field Type",
    "merchantSettings.fieldValue": "Field Value",
    "settings.apiConsumer": "API Consumer",
    "form.role": "Role",
    "form.rolePlaceholder": "Role",
    "merchantUsers.inviteId": "ID",
    "merchantUser.role": "Role",
    "merchantUsers.Resend": "Resend",
    "global.InvitationSuccess": "Successfully invited!",
    "roleAdmin.all": "All",
    "form.role_name": "Role name",
    "form.role_namePlaceholder": "Role name",
    "form.slug": "Slug",
    "roleAdmin.remark": "Remark",
    "roleAdmin.Enabled": "Enabled",
    "roleAdmin.noSpace": "Slug can only consist of letters, numbers and -_",
    "form.slugPlaceholder": "Slug",
    "form.description": "Description",
    "form.descriptionPlaceholder": "Description",
    "form.remark": "Remark",
    "form.remarkPlaceholder": "Remark",
    "form.status": "Status",
    "userAdmin.syncSuccess": "Sync success!",
    "userAdmin.syncFail": "Sync failed!",
    "merchantUsers.all": "All",
    "merchantUsers.refresh": "Refresh",
    "merchantUsers.updated_at": "Last Modified",
    "settings.UserAdmin": "Users",
    "settings.RoleAdmin": "Roles",
    "settings.invitation": "Pending invitation acceptance",
    "admin.userAdmin": "User Admin",
    "LeadSource.dateRange": "Date",
    "dashboard.day": "Today",
    "dashboard.week": "This Week",
    "dashboard.month": "This Month",
    "dashboard.year": "This Year",
    "dashboard.last_x": "Last x days",
    "dashboard.custom": "Custom",
    "form.days": "Days",
    "rules.days": "Please enter a valid number",
    "dashboard.apply": "Apply",
    "global.lastDaysNotCorrect": "The number of last days is not correct",
    "global.dateRangeNotCorrect": "The date range is not correct",
    "global.startTimeLaterEndTime": "The start time cannot be later than the end time",
    "merchantSubscribes.totalsSummary": "Showing {from} to {to} of {total} results",
    "form.isEmail": "Please enter a valid email account",
    "Order.action": "Action",
    "global.ticketDeleteDone": "Deleted successfully.",
    "global.confirmDelModalTitle": "Confirm deletion",
    "global.confirmModalDelMsg": "Are you sure you want to delete this?",
    "form.operator": "Operator",
    "form.operatorPlaceholder": "Operator",
    "form.start_date": "Start date",
    "form.end_date": "End date",
    "inviteAccept.inviteAcceptTitle": "Accept Invitation",
    "inviteAccept.rememberMeLabel": "Remember me",
    "inviteAccept.forgetBtn": "Forget the password?",
    "inviteAccept.signup": "Sign up",
    "inviteAccept.accept": "Accept",
    "global.copyright ": "Copyright @ 2024 BCNetcom. All Rights Reserved",
    "form.verificationCode": "Verification code",
    "form.verificationCodePlaceholder": "Verification code",
    "form.serviceCode": "Service Code",
    "form.placeholder": "Please enter {name}",
    "form.serviceCodePlaceholder": "Service code",
    "form.serviceName": "Service Name",
    "form.serviceNamePlaceholder": "Service name",
    "form.reset": "Reset",
    "form.ok": "Save",
    "form.merchantId": "Merchant ID",
    "form.isRequired": "This field is required",
    "form.cancel": "Cancel",
    "form.firstname": "Firstname",
    "form.firstnamePlaceholder": "Firstname",
    "form.lastname": "Lastname",
    "form.lastnamePlaceholder": "Lastname",
    "form.email": "Email",
    "form.emailPlaceholder": "Email",
    "form.contactEmailPlaceholder": "Contact email",
    "form.phoneArea": "Phone area",
    "form.contactPhone": "Contact phone",
    "navigation.availableApps": "Available apps",
    "navigation.exploreMoreApps": "Explore More Apps",
    "navigation.settings": "Settings",
    "navigation.openAppLauncher": "Open app launcher",
    "navigation.appLauncher": "App launcher",
    "navigation.appLauncherDescription": "Switch between dashboard, active apps, and unavailable apps.",
    "navigation.additionalSubscription": "Available with an additional subscription",
    "global.systemLandingTitle": "Welcome Back !",
    "global.systemLandingMessage": "We will provide you with advanced AI business analytics and powerful CRM system.",
    "DashboardHeader.labelTips": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
    "dashboard.orderPerformanceSummary": "Order performance summary",
    "dashboard.from": "From",
    "dashboard.to": "to",
    "dashboard.revenue": "Revenue",
    "dashboard.vsLastPeriod": "vs. last Period",
    "dashboard.totalOrders": "Total orders",
    "dashboard.averageOrder": "Average order",
    "dashboard.shipping": "Shipping",
    "dashboard.quantity": "Quantity",
    "dashboard.newCustomers": "New Customer with order",
    "dashboard.contacts": "Contacts",
    "dashboard.totalContacts": "Total Contacts",
    "dashboard.momGrowth": "MoM Growth",
    "dashboard.members": "Members",
    "dashboard.totalMembers": "Total Members",
    "dashboard.membersWithOrder": "Members with Order",
    "dashboard.subscribers": "Subscribers",
    "dashboard.totalSubscribers": "Total Subscribers",
    "dashboard.unsubscriptionCurrentMonth": "Unsubscription current month",
    "dashboard.activeAutomatedJourney": "Active automated journey",
    "dashboard.activeCampaigns": "Active Campaigns",
    "dashboard.engagement": "engagement",
    "dashboard.total": "Total",
    "dashboard.status": "Status",
    "dashboard.detail": "Detail",
    "dashboard.customer": "Customer",
    "dashboard.updatedTo": "Updated to 2023-12-12",
    "dashboard.successfulDeal": "Successful Deal",
    "dashboard.dealsCount": "23 deals",
    "dashboard.pendingDeal": "Pending Deal",
    "dashboard.pendingDealsCount": "1045 deals",
    "dashboard.rejectedDeal": "Rejected Deal",
    "dashboard.rejectedDealsCount": "1675 deals",
    "dashboard.upcomingDeal": "Upcoming Deal",
    "dashboard.upcomingDealsCount": "234 deals",
    "homeMenu.merchantAccount": "Merchant Account",
    "homeMenu.myProfile": "My Profile",
    "homeMenu.security": "Security",
    "global.webName": "<spanStyle>e-Com365</spanStyle> is now <linkStyle>Gaxas.ai</linkStyle> — our new brand, with an expanded focus on unified customer engagement and Agentic AI.",
    "global.copyrightText": "Copyright @ 2025 BCNetcom. All Rights Reserved",
    "global.copyrightText2026": "Copyright @ {year} e-Com365.com. All Rights Reserved",
    "homeUser.profile": "Profile",
    "homeUser.loginout": "Sign Out",
    "form.password": "Password",
    "form.newPassword": "New password",
    "form.newPasswordPlaceholder": "New password",
    "form.confirmPassword": "Confirm password",
    "form.confirmPasswordPlaceholder": "Confirm password",
    "form.currentPassword": "Current password",
    "form.currentPasswordPlaceholder": "Current password",
    "form.passwordPlaceholder": "Password",
    "form.firstName": "First name",
    "form.lastName": "Last name",
    "form.userEmail": "User email"


}

export {
    en_US_shell
}    
